var $75a6fa865087050b$exports = {};
$75a6fa865087050b$exports = {
    "(optional)": `(opciono)`,
    "(required)": `(obavezno)`
};


export {$75a6fa865087050b$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
